import { instance } from './instance';
/**
 * Service für Authentifizierungs-API-Anfragen
 */
export const authService = {
  /**
   * Benutzer-Login
   * @param {Object} credentials - Login-Daten (email, password)
   * @returns {Promise} Antwort mit Token und Benutzerdaten
   */
  login(credentials) {
    // Backend erwartet /Auth/login und JSON-Schlüssel in lowercase
    return instance.post('/auth/login', {
      email: credentials.email,
      password: credentials.password
    })
  },

  /**
   * Benutzer-Logout
   * @returns {Promise} Antwort mit Erfolgs- oder Fehlerstatus
   */
  logout() {
    return instance.post('/auth/logout')
  },

  /**
   * Prüft, ob der Benutzer authentifiziert ist
   * @returns {Promise} Antwort mit Authentifizierungsstatus
   */
  checkAuth() {
    return instance.get('/auth/check')
  },

  /**
   * Benutzerregistrierung
   * @param {Object} userData - Benutzerdaten für die Registrierung
   * @returns {Promise} Antwort mit Token und Benutzerdaten
   */
  register(userData) {
    return instance.post('/auth/register', userData)
  },

  changePassword(data) {
    return instance.post('/users/change-password', data)
  },

  getUser() {
    return instance.get('/Auth/user')
  },

  updateProfile(data) {
    return instance.put('/Auth/user', data)
  }
} 